<template lang="pug">
  div.chipList
    van-grid(:column-num="3", :center="false", class="chip_list_select")
      van-grid-item
        div#quality(@click="showQuality")
          span(v-for="(item, index) in qualityPopup" v-if="item.id==qualityActive") {{$t("chipQualityPopup[" + index + "].name")}}
      van-grid-item
        div#attribute(@click="showAttribute")
          span(v-for="(item, index) in attributePopup" v-if="item.id==attributeActive") {{$t("chipAttributePopup[" + index + "].name")}}
      van-grid-item
        div#position(@click="showPosition")
          span(v-for="(item, index) in positionPopup" v-if="item.id==postitionActive") {{$t("chipPositionPopup[" + index + "].name")}}
    van-grid(:column-num="1",:center="false")
      van-grid-item(class="chipItemBox", v-for="item in dataList")
        div.chipItem
          div.chipItemIcon
            img(alt="", v-lazy="require('../assets/chip_icon/'+item.icon)")
          div.chipItemLine
          div.chipItemInfo
            span.chipItemName {{item.name}}
            span.chipItemAttribute {{item.attributeContent}}
    van-popup(v-model="quality", closeable, position="bottom", class="selectPopup")
      div#qualityPopup
        span {{$t("chipList.qualityPopup")}}
        van-grid(:column-num="2", :center="false", class="popup_list_select")
          van-grid-item(v-for="item in qualityPopup")
            div(class="popupGridItem", :class="{active: item.id==qualityActive}", :id="item.id", @click="selectCondition(item.id, '', '')")
              div.left
                img(alt="", v-lazy="require('../assets/chip_quality_icon/'+item.icon)")
              div.right
                span {{item.name}}
    van-popup(v-model="attribute", closeable, position="bottom", class="selectPopup")
      div#attributePopup
        span {{$t("chipList.attributePopup")}}
        van-grid(:column-num="2", :center="false", class="popup_list_select")
          van-grid-item(v-for="item in attributePopup")
            div(class="popupGridItem", :class="{active: item.id==attributeActive}", :id="item.id", @click="selectCondition('', item.id, '')")
              div.left
                img(alt="", v-lazy="require('../assets/weapon_class_icon/'+item.icon)")
              div.right
                span {{item.name}}
    van-popup(v-model="position", closeable, position="bottom", class="selectPopup")
      div#positionPopup
        span {{$t("chipList.positionPopup")}}
        van-grid(:column-num="2", :center="false", class="popup_list_select")
          van-grid-item(v-for="item in positionPopup")
            div(class="popupGridItem", :class="{active: item.id==postitionActive}", :id="item.id", @click="selectCondition('', '', item.id)")
              div.left
                img(alt="", v-lazy="require('../assets/chip_position/'+item.icon)")
              div.right
                span {{item.name}}
</template>

<script>
export default {
  name: 'ChipList',
  data() {
    return {
      quality:false,
      attribute:false,
      position:false,
      attributeContent:false,
      dataList:[],
      chipItemList:[],
      qualityPopup:[],
      attributePopup:[],
      positionPopup:[],
      qualityActive:"7",
      attributeActive:"dn",
      postitionActive:"1",
      showAttributeItem:{},
    }
  },
  created() {
    
  },
  methods:{
    renderingList() {
      this.dataList = []
      for (let index = 0; index < this.chipItemList.length; index++) {
        let item = this.chipItemList[index]
        if(item.quality == this.qualityActive && item.attribute == this.attributeActive && item.postition == this.postitionActive) {
          this.dataList.push(this.$t("chipItemList["+index+"]"))
        }
      }
    },
    showQuality() {
      this.quality = true
    },
    showAttribute() {
      this.attribute = true
    },
    showPosition() {
      this.position = true
    },
    selectCondition(qualityPopup, attributePopup, positionPopup) {
      this.qualityActive = qualityPopup||this.qualityActive
      this.attributeActive = attributePopup||this.attributeActive
      this.postitionActive = positionPopup||this.postitionActive
      this.renderingList()
    },
    showAttributeContent(item) {
      this.attributeContent = true
      for(let i = 0; i < this.chipItemList.length; i++){
          if(this.chipItemList[i].chipId == item.chipId){
            this.showAttributeItem = this.$t("chipItemList["+i+"]")
          }
      }
    }
  },
  components:{

  },
  mounted() {
    let wikiData = require("../assets/lang/zh_CN.json")
    this.chipItemList = wikiData.chipItemList
    this.qualityPopup = this.$t("chipQualityPopup")
    this.attributePopup = this.$t("chipAttributePopup")
    this.positionPopup = this.$t("chipPositionPopup")
    this.$nextTick(() => {
      this.renderingList()
    })    
  }
}
</script>

<style lang="scss">
.chipList {
  .chipItemBox .van-grid-item__content {
    padding: 0px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: transparent;
  }
  .van-hairline--top::after {
    border-top-width: 0px;
  }
  .van-grid-item__content::after {
    border-width: 0px;
  }
  .van-grid-item {
    padding-top: 10px;
    justify-content: center;
    display: flex;
    overflow: hidden;
  }
  .chip_list_select .van-grid-item__content {
    padding: 0;
    width: 90%;
    height: 90%;
    background: url("../assets/chip_list_select_bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .chip_list_select .van-grid-item__content div span{
    float: left;
    width: 80%;
    text-align: left;
    text-indent: 10px;
    font-size: 16px;
    color: #8a948f;
    line-height: 29.4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .chipItem {
    width: 90%;
    align-items: center;
    display: flex;
    background: url("../assets/chip_item_bg.png") center center no-repeat;
    background-size: 100% 100%;
  }
  .chipItemIcon {
    float: left;
    margin-left: 5%;
    align-items: center;
    display: flex;
    width: 20%;
    height: 100%;
  }
  .chipItemLine {
    float: left;
    margin: 0 5% 0 0;
    width: 1px;
    height: 60%;
    border-right: 1px #7b837f solid;
  }
  .chipItemIcon img {
    float: left;
    width: 90%;
  }
  .chipItemInfo {
    float: left;
    margin: 10px 0;
    width: 65%;
    color: #dceae3;
  }
  .chipItemInfo span {
    float: left;
    width: 100%;
    color: #dceae3;
  }
  .chipItemName {
    font-size: 16px;
  }
  .chipItemAttribute {
    font-size: 12px;
  }
  .selectPopup {
    width: 100%;
    height: 228.9px;
    background: url("../assets/select_bg.png") center top no-repeat;
    background-size: cover;
    background-color: transparent;
  }
  .selectPopup span {
    float: left;
    padding-top: 12px;
    width: 100%;
    font-size: 20px;
    text-align: center;
    color: #dceae3;
  }
  .popup_list_select {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 150px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .popup_list_select .van-grid-item__content {
    padding: 0px;
    width: 90%;
    background: url("../assets/select_item_bg.png") center center no-repeat;
    background-size: 100% 100%;
  }
  .popupGridItem {
    padding: 0 10%;
    width: 80%;
  }
  .popupGridItem.active {
    background: url("../assets/select_item_active_bg.png") center center no-repeat;
    background-size: 100% 100%;
  }
  .popupGridItem .left {
    float: left;
    margin-right: 10px;
    text-align: left;
  }
  #qualityPopup .popupGridItem .left {
    margin-top: 8px;
    width: 24px;
  }
  #attributePopup .popupGridItem .left {
    margin-top: 8px;
    width: 18px;
  }
  #positionPopup .popupGridItem .left {
    margin-top: 8px;
    width: 24px;
  }
  .popupGridItem .right {
    float: left;
    margin-top: 8px;
    width: 70%;
  }
  .popupGridItem .right span {
    float: left;
    padding: 0;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #qualityPopup .popupGridItem img {
    width: 100%;
    height: 100%;
  }
  #attributePopup .popupGridItem img {
    width: 100%;
    height: 100%;
  }
  #positionPopup .popupGridItem img {
    width: 100%;
    height: 100%;
  }
}
</style>